import Vue from "vue";
import { getCookie } from "../../../../ask/cookiejs";
import { post, fetch, Del, put } from "../../../../ask/axios";
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue';

export default {
  components: { menberMenu },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },

      titNames: 'My inquiry',
      titUrls: ',',
      myHeaders: {
        ['X-JWT-TOKEN']: getCookie('JWT-TOKEN')
      },

      //------------第一部分查询信息 --------------//
      InquiryName: "",//询盘名称      
      InWaybillNO: '',//询盘单号


      Status: [1, 2, 3, 4, 5],//订单状态,默认显示进行中
      IsState: 6,//订单状态点击，高亮显示
      ////分页
      currentPage: 1, //当前页数
      pageSize: 20, //，每页显示的条数
      total: 0, //查询结果条数


      //-------------空运订单列表数据----------------//
      airInquiryData: [],


      isDataNone: false, //是否有渠道数据
      isLoading: false, //加载中...
      isData: false,

    }
  },
  created() { //创建后
    this.AirInquiryOrderAPI(); //我的询盘列表查询接口
    // setInterval(console.log('dddd'), 1000);

  },
  mounted() { //载入dom后周期函数


  },
  watch: {//监听函数变化        
  },
  computed: {//计算属性
    urlTitle() { //链接头部
      return this.$apiEn
    },
  },

  //方法
  methods: {
    //-------------------------------第一部分查询信息---------------------------------//
    //查询列表接口
    AirInquiryOrderAPI() {
      let that = this;
      this.api.param = {
        InWaybillNO: that.InWaybillNO.replace(/(^\s*)|(\s*$)/g, ""),//
        InquiryName: that.InquiryName.replace(/(^\s*)|(\s*$)/g, ""),//
        CusStatus: that.Status,//
        Skip: (this.currentPage - 1) * this.pageSize,
        Take: this.pageSize

      };
      that.isLoading = true; //加载中...
      that.isDataNone = false; //没有数据查无订单
      that.isData = false; //有数据列表

      this.api.url = this.$api04 + "/Air/api/AirInquiryOrder/CustomerQuery"
      post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.isLoading = false;
          if (res.Results) {
            if (res.Results.length <= 0) {
              that.isDataNone = true;
              that.isDataNone != that.isLoading;
            } else {
              that.isDataNone = false;
              that.isData = true;
            }
          }

          that.airInquiryData = res.Results
          that.total = res.Total

          if (that.airInquiryData.length > 0) {
            that.airInquiryData.forEach(e => {
              setInterval(() => {
                e.CountDown--;
                if (e.CountDown <= 0) {
                  e.CountDown = 0
                }
              }, 60000);
            })
          }

        } else {
          that.isLoading = false;
          that.isDataNone = true;
          that.isData = false;
        }

      })
    },
    //查询订单按钮
    btnQuery() {
      this.currentPage = 1
      this.AirInquiryOrderAPI();//调用接口
    },
    //选中订单状态筛选订单
    clkBtnState(val) {
      this.IsState = val
      switch (val) {
        case 1:
          this.Status = [1]
          break;
        case 2:
          this.Status = [2]
          break;
        case 3:
          this.Status = [3]
          break;
        case 4:
          this.Status = [4]
          break;
        case 5:
          this.Status = [5]
          break;
        case 6:
          this.Status = [1, 2, 3, 4, 5]
          break;
      }

      this.btnQuery(); //订单查询按钮

      //console.log('msg   ' + JSON.stringify(msg))
    },
    //分页按钮
    handleSizeChange(val) {
      this.pageSize = val
      this.AirInquiryOrderAPI()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.AirInquiryOrderAPI()
    },
    //订单状态转换 
    transStatus(val) {
      // 客户状态。1：询价中，2：待确认，3：已下单，4：已过期
      if (val == 1) return 'In inquiry'
      if (val == 2) return 'To be confirmed'
      if (val == 3) return 'Booked'
      if (val == 4) return 'Expired'
      if (val == 5) return 'Closed'
    },
    //把分钟转成小时，例如90分钟，1:30
    mToStr(m) {
      let h = Math.floor(m / 60);
      m -= h * 60;
      let hStr = h.toString().length;
      let mStr = m.toString().length;

      if (hStr > 1 && mStr > 1) {
        return (h ? h + ':' : '00:') + (m ? m : '00')
      } else if (hStr > 1 && mStr == 1) {
        return (h ? h + ':' : '00:') + (m ? '0' + m : '00')
      } else if (hStr == 1 && mStr == 1) {
        return (h ? '0' + h + ':' : '00:') + (m ? '0' + m : '00')
      } else if (hStr == 1 && mStr > 1) {
        return (h ? '0' + h + ':' : '00:') + (m ? m : '00')
      }
    },

    //点击查看详情埋点
    clkDetails(item) {

      let startText = ''
      if (item.OrderServiceType == 1 || item.OrderServiceType == 2) {
        //startText=item.StartProNameEn+','+item.StartCityNameEn+','+item.StartCityAreaNameEn
        startText = item.StartProNameEn
      } else {
        //startText=item.DepartureCode+','+item.DepartureNameEn
        startText = item.DepartureCode
      }

      let endText = ''
      if (item.OrderServiceType == 1 || item.OrderServiceType == 4) {
        //endText=item.DestAddressDesc
        endText = item.DestCountryNameCn
      } else {
        //endText=item.DestinationCode+','+item.DestinationNameEn
        endText = item.DestinationCode
      }

      this.viewResult(
        item.InWaybillNO,
        startText,
        item.StartCountryNameEn,
        endText,
        item.DestCountryNameEn,
        item.Weight,
        this.transServType(item.OrderServiceType),
        item.VolumeCBM,
        '',
        item.PackageQuanlity,
      )

      this.$router.push({ path: '/myInquiry/airInDetails', query: { billNO: item.InWaybillNO } })

    },

    transServType(val) {
      // 订单服务类型。1：门到门，2：门到机场，3：机场到机场，4：机场到门
      if (val == 1) return 'Door To Door'
      if (val == 2) return 'Door To Terminal'
      if (val == 3) return 'Terminal To Terminal'
      if (val == 4) return 'Terminal To Door'
    },










  }
}


// WEBPACK FOOTER //
// ./src/assets/js/userCenter/myInquiry/airInquiry.js